import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification'

import { GraphSearchItemServiceService } from '../services/graph-search-item-service.service'

@Component({
  selector: 'app-graph-search-item',
  templateUrl: './graph-search-item.component.html',
  styleUrls: ['./graph-search-item.component.css']
})
export class GraphSearchItemComponent implements OnInit {

  constructor(
    private graphSearchItemService: GraphSearchItemServiceService,
    private fb: FormBuilder,
    private notification: NzNotificationService
  ) {
    this.startNodeForm = this.fb.group({})
  }

  ngOnInit() {
    this.showSearchType = (this.searchType == 'startNode' || this.searchType == 'endNode')? "Entity": "Relation";
    this.graphSearchItemService.getLabels(this.searchType).subscribe((data:any[])=>{this.labels = data;}, error=>{
      this.notification.create(
        "error",
        'Oooooops~~~~',
        'Something went wrong when getting labels of entity. Please check your network and try it again.'
      );
    });
  }

  @Input()
  private searchType: string;


  startNodeForm!:FormGroup;
  listOfControl: Array<{ id: number;controlInstance: string; attrName: string; optNum: string; reference: string;}> = []

  showSearchValue = null;
  labelSelect = 'all';
  labels = [];
  properties = [];

  showSearchType = null;
  
  
/*
  setShowSearchType() {
    if(this.searchType == 'startNode' || this.searchType == 'endNode'){
      this.showSearchType = "实体";
    }
    else if(this.searchType == "relation") {
      this.showSearchType = "关系";
    }
  }
*/

  addField(e?: MouseEvent): void {
    if(e) {
      e.preventDefault();
    }
    const id = this.listOfControl.length > 0? this.listOfControl[this.listOfControl.length - 1].id + 1 : 0;

    const control = {
      id,
      controlInstance: 'controlInstance' + id,
      attrName: null,
      optNum: null,
      reference: null
    }
    const index = this.listOfControl.push(control);
    console.log(this.listOfControl[this.listOfControl.length - 1]);
    this.startNodeForm.addControl(this.listOfControl[index - 1].controlInstance, new FormControl(null));
  }


  removeField(i: { id: number; controlInstance: string; attrName: string; optNum: string; reference: string}, e:MouseEvent): void {
    console.log("event start")
    e.preventDefault();
    if(this.listOfControl.length > 0) {
      const index = this.listOfControl.indexOf(i);
      this.listOfControl.splice(index, 1);
      console.log(this.listOfControl);
      this.startNodeForm.removeControl(i.controlInstance);
    }
  }

  getProperties(startSelect) {
    this.graphSearchItemService.getProperties(startSelect, this.searchType).subscribe((data:any[])=>{this.properties = data;}, error => {
      this.notification.create(
        "error",
        'Oooooops~~~~',
        'Something went wrong when getting properties of entity. Please check your network and try it again.'
      );
    })
    if(this.listOfControl.length > 0){
      this.listOfControl = []
    }
    this.addField()
  }

  setValue() {
    if(this.searchType == "startNode") {
      this.graphSearchItemService.setStartNodeValue(this.labelSelect, this.listOfControl)
    }
    else if(this.searchType == "relation") {
      this.graphSearchItemService.setRelationValue(this.labelSelect, this.listOfControl)
    }
    else if(this.searchType == "endNode") {
      this.graphSearchItemService.setEndNodeValue(this.labelSelect, this.listOfControl)
    }
  }

  
}
